import { SxProps, Theme } from '@mui/material/styles';

export const newMostTitleSX = (isHref: boolean): SxProps<Theme> => ({
	color: '#333333 !important',
	textTransform: 'uppercase',
	mb: 0,
});
